import { reflectKeys } from "@utils/key.reflactor";
import { DICTIONARY_LANGUAGES } from "@plugins/dictionary/dictionary.constant";
export const CHARACTER_LIMIT = {
  EMAIL: 250,
  APP_NAME: 250,
  APP_DESCRIPTION: 500,
  APP_DIVISION: 250,
  APP_BRANCH: 250,
  APP_CONTACT_MAX: 99999999999999999999,
  APP_CONTACT_MIN: 10000000,
  APP_PUBLIC_KEY: 500,
  APP_URL: 250,
  APP_WHITELISTED_DOMAIN: 50,
  APP_WHITELISTED_DOMAIN_LIST: 510,
  APP_AUTH_TOKEN: 250,
  APP_ENDPOINT_URL: 250,
  APP_KEYWORDS: 250,
};

export const APP_WHITELISTED_DOMAINS_SIZE_LIMIT = 10;

export const APP_TYPE = reflectKeys(["LTI13", "INTEGRATOR"]);

export const ALL_OPTION = { value: "ALL", label: "app_permissions_add_select_all" };

export const LANGUAGE_SETTINGS_OPTIONS = {
  EN: { value: "EN", displayName: "English Language" },
  ZH: { value: "ZH", displayName: "中文" },
  MS: { value: "MS", displayName: "Bahasa Melayu" },
  TA: { value: "TA", displayName: "தமிழ்மொழி" },
};

export const TRANSCRIPTION_LANGUAGE_SETTINGS_OPTIONS = {
  EN: { value: "EN", displayName: "English Language" },
  ZH: { value: "ZH", displayName: "中文" },
  MS: { value: "MS", displayName: "Bahasa Melayu" },
  TA: { value: "TA", displayName: "தமிழ்மொழி" },
  MULTI: { value: "MULTI", displayName: "Multi" },
};

// Used in LessonSettingsEdit and LessonSettingsView
export const DICTIONARY_OPTIONS = {
  NONE: { value: "", displayName: "dictionary_empty_label", language: null },
  ZH: {
    value: "zh",
    displayName: "chinese_language_label",
    language: DICTIONARY_LANGUAGES.ZH.name,
  },
  EN_ZH: {
    value: "en,zh",
    displayName: "cl_with_el_translation_label",
    language: DICTIONARY_LANGUAGES.ZH.name,
  },
  MS: { value: "ms", displayName: "malay_language_label", language: DICTIONARY_LANGUAGES.MS.name },
  TA: { value: "ta", displayName: "tamil_language_label", language: DICTIONARY_LANGUAGES.TA.name },
  EN_TA: {
    value: "en,ta",
    displayName: "ta_with_el_translation_label",
    language: DICTIONARY_LANGUAGES.TA.name,
  },
};

export const ALL_PERMISSIONS = {
  ALL_SCHOOLS: "ALL SCHOOLS",
  ALL_SUBJECTS: "ALL SUBJECTS",
  ALL_LEVELS: "ALL LEVELS",
};

export const MAX_LENGTH = {
  PERMISSIONS: 100,
};
